export default {"src":"/_next/static/media/download.e7db6106.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};